define('views/modules/calendar/animated-session/animation/animation-edit-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    'services/events/animated-session-events',
    // views
    'views/parts/modal/modal',
    'views/modules/calendar/animated-session/custom-exercises-manager/edit/custom-exercise-edit-content-modal'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    AnimationEvents,
    // views
    VModal,
    VCustomExerciseEditContentModal
) {

    var VAnimationEditModal = VModal.extend({
        template: '<form id="animation-edit-form"></form>\n',
        modal: {
            title: '',
            className: "animation-edit-modal",
            backdrop: true,
            closeButton: false,
        },
        buttons: function(buttons) {
            return _.extend(buttons, {
                confirm: {
                    label: i18n.t("Save"),
                    callback: this.onConfirm,
                    className: "btn-primary"
                }
            });
        },

        regions: {
            form: '#animation-edit-form'
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.model = opt.model;
            this.group = this.options.group;

            var view = this.view = {
                form: new VCustomExerciseEditContentModal({
                    model: this.model
                })
            };

            this.listenTo(view.form, 'form:success', this.onSuccess);
        },

        render: function() {
            this.$el.empty()
                .append(Mustache.render(this.template, Mustache.getContext()));

            this.modal.title = i18n.t('calendar:edit-custom-exercise-modal');

            this.generateZones()
                .assign(this.view.form, this.zone.$form)
                .renderModal();

            return this;
        },

        onRevertBack: function() {
          this.animation.trigger('animation:revertback');
        },

        onConfirm: function(result) {
            this.view.form.submit();
            return false;
        },

        onSuccess: function() {
            this.close();
            this.trigger('form:success');
            AnimationEvents.exerciseEdited(this.view.form.model);
        },
    });

    return VAnimationEditModal;

});

